import React, { useState, useEffect } from 'react';
import { graphql } from 'gatsby';
import SEO, { createSEO } from 'components/SEO';
import WebsiteLayout from 'layouts/websiteLayout';
import JobPostsHeroSection from 'components/JobOpeningsPage/JobPostsHeroSection';
import useGlobalHeader from 'hooks/useGlobalHeader';
import useGlobalFooter from 'hooks/useGlobalFooter';

const JobPostsPage = props => {
  const [jobCards, setJobCards] = useState([]);
  const header = useGlobalHeader();
  const footer = useGlobalFooter();

  useEffect(() => {
    const jobData = props.data.allWorkdayJob.edges.map(({ node }) => ({
      title: node.title,
      absolute_url: node.url,
      description: node.jobDescription,
      department: node.jobFamilyGroup,
      locations: node.locations,
    }));

    setJobCards(
      [...new Set(jobData.map(x => x.department))].map(x => ({
        name: x,
        description: '',
        jobs: jobData.filter(y => y.department === x),
      }))
    );
  }, []);

  const seo = createSEO(
    {
      ...props.data.contentfulWebsitePage?.seo,
    },
    props
  );

  const breadcrumbs = {
    data: [
      {
        title: 'Careers',
        icon: null,
        url: '/careers',
      },
      {
        title: 'Job Openings',
        icon: null,
        url: null,
      },
    ],
    absolute: true,
  };

  return (
    <WebsiteLayout
      header={header}
      footer={footer}
      backgroundColor="var(--neutral-1)"
      breadcrumbs={breadcrumbs}
      stickyHeader
    >
      <SEO {...seo} />
      <JobPostsHeroSection
        background="#F6F8FA"
        title="Job Openings"
        description="Find a role on one of our inspiring teams!"
        jobCards={jobCards}
      />
    </WebsiteLayout>
  );
};

export default JobPostsPage;

export const JobPostsPageQuery = graphql`
  query JobPostsPageQuery {
    contentfulWebsitePage(internalName: { eq: "Job Openings" }) {
      seo {
        ...Seo
      }
    }
    allWorkdayJob {
      edges {
        node {
          ...WorkdayJob
        }
      }
    }
  }
`;
